// src/pages/VisiMisiGpib.jsx
import React from 'react';

const VisiMisiGpib = () => {
    return (
        <div className="bg-white text-gray-900 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-10">
                    <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 mb-2">
                        VISI & MISI GPIB
                    </h1>
                    <p className="text-lg text-gray-600">
                        GPIB Jemaat "Kasih Karunia" Badung-Bali
                    </p>
                </div>

                {/* Bagian Visi */}
                <div className="mb-10 p-6 bg-gray-50 rounded-xl shadow-sm border border-gray-200">
                    <h2 className="text-3xl font-bold mb-4 text-blue-800">
                        VISI
                    </h2>
                    <p className="text-lg leading-relaxed text-gray-700">
                        GPIB menjadi gereja yang mewujudkan damai sejahtera bagi seluruh ciptaan, melalui kesaksian dan pelayanan yang transformatif, dan menjadi mitra Allah dalam mewujudkan Kerajaan-Nya di tengah dunia.
                    </p>
                </div>

                {/* Bagian Misi */}
                <div className="p-6 bg-gray-50 rounded-xl shadow-sm border border-gray-200">
                    <h2 className="text-3xl font-bold mb-4 text-blue-800">
                        MISI
                    </h2>
                    <ul className="list-disc list-outside pl-6 space-y-3 text-lg leading-relaxed text-gray-700">
                        <li>Mengembangkan kualitas keimanan jemaat yang dewasa, mandiri, dan misioner.</li>
                        <li>Memperkuat persekutuan yang berlandaskan kasih, keadilan, dan kebenaran.</li>
                        <li>Mewujudkan pelayanan yang holistik, inklusif, dan transformatif di berbagai aspek kehidupan.</li>
                        <li>Menjadi gereja yang berdaya, peduli lingkungan, dan berpihak pada kaum miskin dan tertindas.</li>
                        <li>Memperjuangkan keesaan gereja dan menjadi berkat bagi bangsa dan negara.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VisiMisiGpib;